import script from "./ArrowDownUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArrowDownUp.vue?vue&type=script&setup=true&lang=ts"

import "./ArrowDownUp.vue?vue&type=style&index=0&id=1d2c61b3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2c61b3"]])

export default __exports__